import { templateConstants } from "../../../../constants/cms/template/template.constants";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import { arrayHelper } from "../../../../helpers/arrayHelper";
import { deepClone } from "../../../../helpers/objectHelper";
import { templateHelper } from "../../../../cms/areas/template/helpers/templateHelper";

const initialState = {
  selectedElement: null,
  selectedContainer: null,
  isSavable: false,
  history: [],
  currentVersion: {},
  isMenuModalOpen: false,
  /*   template: undefined, */
  templates: [],
  usedColors: [],
  previewDevice: templateConstants.DESKTOP,
};

export function template(state = initialState, action) {
  switch (action.type) {
    case templateConstants.UNDO_CHANGE:
      /*     const indexOfCurV = state.history.find((v, i) => {
            return v.timeStamp === state.currentVersion.timeStamp
          })
          const indexOfPrevV = state.history.indexOf(indexOfCurV, - 1) */
      return {
        ...state,
        loading: true,
      };
    case templateConstants.REDO_CHANGE:
      return {
        ...state,
        templates: [...state.templates, action.template],
        loading: false,
      };
    case templateConstants.TOGGLE_PREVIEW_MODE:
      return {
        ...state,
        previewDevice: action.device,
      };
    case templateConstants.CREATE_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case templateConstants.CREATE_TEMPLATE_SUCCESS:
      return {
        ...state,
        templates: [...state.templates, action.template],
        loading: false,
      };
    case templateConstants.CREATE_TEMPLATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case templateConstants.GET_DEFAULT_TEMPLATE_BY_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case templateConstants.GET_DEFAULT_TEMPLATE_BY_EVENT_SUCCESS:
      return {
        ...state,
        template: action.template,
        currentVersion: { ...action.template, timeStamp: Date.now() },
        loading: false,
      };
    case templateConstants.GET_DEFAULT_TEMPLATE_BY_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case templateConstants.GET_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case templateConstants.SET_MENU:
      return {
        ...state,
        menu: action.menu,
      };
    case templateConstants.GET_TEMPLATE_SUCCESS:
      const template = deepClone(action.template);
      template.content.header.content.map((h) => {
        h.parentName = "HEADER";
      });
      template.content.footer.content.map((h) => {
        h.parentName = "FOOTER";
      });
      const usedColors = templateHelper.getTemplatesColors(template);
      return {
        ...state,
        menu: action.menu,
        template: template,
        newStyle: action.template.css,
        usedColors,
        /*         currentVersion: action.template, */
        loading: false,
      };
    case templateConstants.TOGGLE_MENU_MODAL:
      return {
        ...state,
        isMenuModalOpen: !state.isMenuModalOpen,
      };
    case templateConstants.GET_TEMPLATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case templateConstants.GET_TEMPLATE_BY_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case templateConstants.GET_TEMPLATE_BY_EVENT_SUCCESS:
      return {
        ...state,
        templates: action.templates,
        currentVersion: { ...action.template, timeStamp: Date.now() },
        loading: false,
      };
    case templateConstants.GET_TEMPLATE_BY_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case templateConstants.DELETE_TEMPLATE_ELEMENT_SUCCESS:
      const updatedTemplate = deepClone(state.template);
      let source = null;
      let container = null;
      let elementToRemove = null;

      if (action.source === undefined || !action.source) {
        if (
          state.template.content.header.content.find((el) => {
            return el.contentId === action.element.contentId;
          })
        ) {
          container = "HEADER";
          elementToRemove = state.template.content.header.content.find((el) => {
            return el.contentId === action.element.contentId;
          });
          source = [
            ...state.template.content.header.content.sort((a, b) => {
              let x = a.sortOrder;
              let y = b.sortOrder;
              return y < x ? 1 : y > x ? -1 : 0;
            }),
          ];
        }
        if (
          state.template.content.footer.content.find((el) => {
            return el.contentId === action.element.contentId;
          })
        ) {
          container = "FOOTER";
          elementToRemove = state.template.content.footer.content.find((el) => {
            return el.contentId === action.element.contentId;
          });
          source = [
            ...state.template.content.footer.content.sort((a, b) => {
              let x = a.sortOrder;
              let y = b.sortOrder;
              return y < x ? 1 : y > x ? -1 : 0;
            }),
          ];
        }
      }
      if (action.source === "HEADER") {
        container = "HEADER";
        elementToRemove = action.element;
        source = [
          ...state.template.content.header.content.sort((a, b) => {
            let x = a.sortOrder;
            let y = b.sortOrder;
            return y < x ? 1 : y > x ? -1 : 0;
          }),
        ];
      }
      if (action.source === "FOOTER") {
        container = "FOOTER";
        elementToRemove = action.element;
        source = [
          ...state.template.content.footer.content.sort((a, b) => {
            let x = a.sortOrder;
            let y = b.sortOrder;
            return y < x ? 1 : y > x ? -1 : 0;
          }),
        ];
      }

      var indexOfRemovedEl = source.indexOf(elementToRemove);
      if (indexOfRemovedEl > -1) {
        source.splice(indexOfRemovedEl, 1);
        for (let index = indexOfRemovedEl; index < source.length; index++) {
          source[index].sortOrder = index + 1;
        }
      }

      if (action.element.type === elementConstants.CONTAINER) {
        const containerChildren = [
          ...source.filter((el, index) => {
            return el.parentId === action.element.id;
          }),
        ];
        const containerChildrenChildren = [
          ...source.filter((el, index) => {
            if (containerChildren.find((cel) => cel.id === el.parentId))
              return el;
          }),
        ];
        containerChildren.map((el, index) => {
          let elToRemove = source.find((sc, i) => {
            return sc.contentId === el.contentId;
          });
          source.splice(source.indexOf(elToRemove), 1);
        });
        containerChildrenChildren.map((el, index) => {
          let elToRemove = source.find((sc, i) => {
            return sc.contentId === el.contentId;
          });
          source.splice(source.indexOf(elToRemove), 1);
        });
      }
      if (container === "HEADER") {
        updatedTemplate.content.header.content = source;
        return {
          ...state,
          template: updatedTemplate,
          selectedElement: null,
          isSavable: true,
        };
      }
      if (container === "FOOTER") {
        updatedTemplate.content.footer.content = source;
        return {
          ...state,
          template: updatedTemplate,
          selectedElement: null,
          isSavable: true,
        };
      }
    case templateConstants.DESELECT_SUCCESS:
      return {
        ...state,
        selectedElement: null,
        selectedContainer: null,
      };
    case templateConstants.SELECT_TEMPLATE_ELEMENT:
      source = action.element.parentName === "HEADER" ? "header" : "footer";
      if (
        action.element.type === elementConstants.CONTAINER &&
        action.element.parentId === null
      ) {
        const containerId = action.element.id;
        const containerChildId = state.template.content[source].content
          .filter((el) => {
            return el.parentId === containerId;
          })
          .map((el) => {
            return el.id;
          });
        const hasChildren = state.template.content[source].content.filter(
          (el) => {
            return containerChildId.includes(el.parentId);
          }
        );
        if (hasChildren.length > 0) {
          return {
            ...state,
            selectedContainer: action.element,
          };
        }
      }

      if (
        state.template.content[source].content.find((el) => {
          return el.contentId === action.element.contentId;
        }) &&
        action.element.type === elementConstants.CONTAINER &&
        action.element.parentId === null
      ) {
        return {
          ...state,
          selectedContainer: action.element,
          selectedElement: null,
        };
      }
      const parentChild = state.template.content[source].content.find((el) => {
        return el.id === action.element.parentId;
      });

      if (parentChild && state.selectedContainer) {
        if (parentChild.parentId === state.selectedContainer.id) {
          return {
            ...state,
            selectedElement: action.element,
          };
        }
      } else {
        return {
          ...state,
          selectedElement: action.element,
          selectedContainer:
            state.selectedContainer &&
            action.element.parentId !== state.selectedContainer.Id
              ? null
              : state.selectedContainer,
        };
      }

      if (
        action.element.type === elementConstants.CONTAINER &&
        action.element.parentId === null
      ) {
        return {
          ...state,
          selectedContainer: action.element,
          /*  selectedElement: state.selectedElement && action.element.parentId  !== state.selectedContainer.Id ? null : state.selectedContainer */
        };
      }
      return {
        ...state,
        selectedElement: action.element,
        selectedContainer:
          state.selectedContainer &&
          action.element.parentId !== state.selectedContainer.Id
            ? null
            : state.selectedContainer,
      };
    case templateConstants.SOFT_UPDATE_TEMPLATE:
      let newSelectedContainer = null;
      if (state.selectedContainer) {
        let source =
          state.selectedContainer.parentName === "HEADER" ? "header" : "footer";
        newSelectedContainer = deepClone(
          action.template.content[source].content.find((c) => {
            return c.contentId === state.selectedContainer.contentId;
          })
        );
      }
      let newSelectedElement = null;
      if (state.selectedElement) {
        let source =
          state.selectedElement.parentName === "HEADER" ? "header" : "footer";
        newSelectedElement = deepClone(
          action.template.content[source].content.find((c) => {
            return c.contentId === state.selectedElement.contentId;
          })
        );
      }
      return {
        ...state,
        template: action.template,
        history: [
          ...state.history,
          { ...action.template, timeStamp: Date.now() },
        ],
        isSavable: true,
        selectedElement: newSelectedElement,
        selectedContainer: newSelectedContainer,
        loading: true,
      };
    case templateConstants.SET_TEMPLATE_FROM_FORM_REQUEST:
      return {
        ...state,
        setting: true,
        template: action.template,
      };
    case templateConstants.SET_TEMPLATE_FROM_FORM:
      return {
        ...state,
        setting: false,
        template: action.template,
      };
    case templateConstants.UPDATE_TEMPLATE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case templateConstants.UPDATE_TEMPLATE_SUCCESS:
      return {
        ...state,
        template: action.template,
        newStyle: action.template.css,
        updated: action.template.updated,
        isSavable: false,
      };
    case templateConstants.UPDATE_TEMPLATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
